import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
    return (
        <div data-testid="terms-page" className="bg-[#0A0A0E] text-zinc-100 min-h-screen">
            <Navbar />
            <main className="pt-28 pb-20 max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
                <Link to="/" className="inline-flex items-center gap-2 text-sm text-zinc-400 hover:text-cyan-300 mb-6">
                    <ArrowLeft size={14} /> Back
                </Link>
                <span className="section-tag">Legal</span>
                <h1 className="font-display text-4xl sm:text-5xl text-white mt-5 tracking-tighter">Terms &amp; Conditions</h1>
                <p className="text-xs font-mono-accent text-zinc-500 mt-3 uppercase tracking-[0.18em]">
                    Last updated · December 2025
                </p>

                <div className="mt-10 space-y-6 text-zinc-300 text-base leading-relaxed">
                    <p>
                        These terms govern your use of the WE DELVR LOGISTICS website and any preview
                        services offered through it. By using this site you agree to these
                        terms.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">1. Preview services</h2>
                    <p>
                        Container tracking, market data and platform demonstrations available
                        on this site are illustrative previews. They are not a substitute for
                        a contracted commercial service. Data accuracy and availability are
                        not guaranteed.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">2. No professional advice</h2>
                    <p>
                        Content on this site is provided for information only and does not
                        constitute legal, financial, tax or freight forwarding advice. Engage
                        WE DELVR LOGISTICS formally for tailored advisory work.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">3. Intellectual property</h2>
                    <p>
                        All content, design and branding on this site are owned by WE DELVR LOGISTICS
                        PTY LTD or its licensors. You may not copy or reproduce them without
                        written permission.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">4. Liability</h2>
                    <p>
                        To the maximum extent permitted by law, WE DELVR LOGISTICS is not liable for any
                        indirect, incidental or consequential loss arising from use of this
                        site or any preview service.
                    </p>

                    <h2 className="font-display text-xl text-white mt-8">5. Governing law</h2>
                    <p>
                        These terms are governed by the laws of New South Wales, Australia.
                    </p>

                    <p className="text-xs font-mono-accent text-zinc-500 mt-10 uppercase tracking-[0.18em]">
                        Template terms provided for the WE DELVR LOGISTICS preview site. Review with
                        qualified legal counsel before public release.
                    </p>
                </div>
            </main>
            <Footer />
        </div>
    );
}
